import getMessage from 'src/background/utils/i18n.utils';
import { WitnessInfoDataComponent } from '@popup/steem/pages/app-container/home/governance/my-witness-tab/witness-information/witness-info-data/witness-info-data.component';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import React from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
const WitnessGlobalInformation = ({ witnessInfo, currencyLabels, }) => {
    const gotoUrl = (url) => {
        window.open(url);
    };
    return (React.createElement("div", { className: "witness-global-information" },
        React.createElement("div", { className: "info-panel" },
            React.createElement(WitnessInfoDataComponent, { label: 'html_popup_witness_global_information_votes_label', value: witnessInfo.votesCount }),
            React.createElement(WitnessInfoDataComponent, { label: 'html_popup_witness_information_votes_label', value: `${witnessInfo.voteValueInSP} ${currencyLabels.sp}` }),
            React.createElement(WitnessInfoDataComponent, { label: 'html_popup_witness_global_information_blocks_missed_label', value: witnessInfo.blockMissed }),
            React.createElement(WitnessInfoDataComponent, { label: 'html_popup_witness_global_information_last_block_label', value: witnessInfo.lastBlock, valueOnClickAction: () => gotoUrl(witnessInfo.lastBlockUrl) }),
            React.createElement(WitnessInfoDataComponent, { label: 'html_popup_witness_global_information_price_feed_label', value: witnessInfo.priceFeed, extraInfo: getMessage('html_popup_witness_global_information_updated_label', [witnessInfo.priceFeedUpdatedAt.fromNow()]), extraInfoAdditionalClass: `info-last-update ${witnessInfo.priceFeedUpdatedAtWarning ? 'warning-red-color' : ''}` }),
            React.createElement(WitnessInfoDataComponent, { label: 'html_popup_witness_global_information_version_label', value: witnessInfo.version }))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        activeAccount: state.steem.activeAccount,
        currencyPrices: state.steem.currencyPrices,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        globalProperties: state.steem.globalProperties,
    };
};
const connector = connect(mapStateToProps, {});
export const WitnessGlobalInformationComponent = connector(WitnessGlobalInformation);
